var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('Tabs',{attrs:{"tabs":_vm.tabs,"level":2,"tab-lv1-index":_vm.tabLv1Index,"tabs-lv1-count":_vm.tabsLv1Count}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }